import pino from "pino";

// In the browser, we want the message component of the log object to be
// displayed as regular text, followed by the structured data from the log call
const splitAndLog = (fn) => {
  return (o) => {
    const { msg, ...rest } = o;
    fn(msg, rest);
  };
};

const logger = pino({
  level: "debug",
  browser: {
    asObject: true,
    write: {
      trace: splitAndLog(console.debug),
      debug: splitAndLog(console.debug),
      info: splitAndLog(console.log),
      warn: splitAndLog(console.warn),
      error: splitAndLog(console.error),
      fatal: splitAndLog(console.error),
    },
  },
});

logger.debug({ Lokalyze: true }, "logger initialised");

export default logger;
